import z from "zod";

export const communitiesAdminSettingsGlobalSchema = z.object({
  admin_only_small_group_creation: z.enum(["true", "false"]).optional(),
  allow_youth_access: z.enum(["true", "false"]).optional(),
});

export const communitiesAdminSettingsSchema = z.object({
  global: communitiesAdminSettingsGlobalSchema,
});

export type CommunitiesAdminSettingsGlobal = z.infer<
  typeof communitiesAdminSettingsGlobalSchema
>;

export type CommunitiesAdminSettings = z.infer<
  typeof communitiesAdminSettingsSchema
>;
